<template>
  <SoWidget>
    <SoExpansionPanels>
      <SoExpansionPanel>
        <template #title>
          <SoAvatar class="mr-6" :type="icon" data-testid="feeditem-icon" />
          <div>
            <div class="d-flex align-center">
              <h6 class="font-weight-medium">{{ title }}</h6>
              <SoChip
                v-if="chip"
                :text="chip"
                :type="SoChipType.DEFAULT"
                class="ml-3"
                data-testid="feeditem-chip"
              />
            </div>
            <div class="text-body-1 text-medium-emphasis d-flex align-center">
              {{ formatDate(date) }}
              <template v-if="subtitle">
                <span class="subtitle__bullet">&#8226;</span>
                {{ subtitle }}
              </template>
            </div>
          </div>
          <v-spacer />
          <SoStatus
            v-if="status"
            :status="status"
            class="mr-2"
            data-testid="feeditem-status"
          />
        </template>
        <template #default>
          <div v-if="!isEmpty(alert)" class="ml-14 mr-8">
            <SoAlert
              :type="alert.type"
              :title="alert.title"
              class="my-2"
              data-testid="feeditem-alert"
            >
              <div v-html="alert.content" />
            </SoAlert>
            <SoExpansionPanels>
              <SoExpansionPanel no-padding>
                <template #title>More details</template>
                <SoErrorBoundary>
                  <slot></slot>
                </SoErrorBoundary>
              </SoExpansionPanel>
            </SoExpansionPanels>
          </div>
          <div v-else class="pl-14">
            <SoErrorBoundary>
              <slot></slot>
            </SoErrorBoundary>
          </div>
        </template>
      </SoExpansionPanel>
    </SoExpansionPanels>
  </SoWidget>
  <SoDivider vertical class="ml-10" style="height: 24px" />
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { Dayjs } from "dayjs"
  import { formatDateTime } from "@/helpers/dateHelper"
  import { AvatarTypes } from "../SoAvatar.vue"
  import { Status } from "@/types/Status"
  import SoWidget from "../SoWidget.vue"
  import SoAvatar from "../SoAvatar.vue"
  import SoDivider from "../SoDivider.vue"
  import SoExpansionPanel from "../expansionPanels/SoExpansionPanel.vue"
  import SoExpansionPanels from "../expansionPanels/SoExpansionPanels.vue"
  import SoErrorBoundary from "../SoErrorBoundary.vue"
  import SoStatus from "../SoStatus.vue"
  import SoChip from "../SoChip.vue"
  import { SoChipType } from "@/types/components/SoChip"
  import SoAlert from "../SoAlert.vue"
  import { IFeedItemAlert } from "@/models/activityFeed/ActivityFeedItem"
  import { isEmpty } from "@/helpers/objectHelpers"

  export default defineComponent({
    components: {
      SoWidget,
      SoAvatar,
      SoDivider,
      SoExpansionPanel,
      SoExpansionPanels,
      SoErrorBoundary,
      SoStatus,
      SoChip,
      SoAlert,
    },
    inheritAttrs: false,
    props: {
      icon: {
        type: String as PropType<AvatarTypes>,
        default: null,
      },
      title: {
        type: String,
        required: true,
        default: null,
      },
      subtitle: {
        type: String,
        default: null,
      },
      date: {
        type: Dayjs,
        required: true,
        default: null,
      },
      status: {
        type: Object as PropType<Status>,
        default: null,
      },
      alert: {
        type: Object as PropType<IFeedItemAlert>,
        default: null,
      },
      chip: {
        type: String,
        default: null,
      },
    },
    data: () => ({
      formatDate: formatDateTime,
      isEmpty,
      SoChipType,
    }),
  })
</script>
<style scoped>
  .subtitle__bullet {
    font-size: 10px;
    margin: 0 8px;
  }
</style>
